export default __webpack_public_path__ + "static/media/vision_home.4d020000.svg";